import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.7', color: '#333' }}>
      <h1 style={{ color: '#1a6b4a' }}>Terms of Service</h1>
      <p><strong>Effective Date:</strong> June 1, 2026</p>
      <p>Welcome to <strong>Elite Goats</strong>. By using our platform, you agree to the following terms and conditions.</p>
      <h2>1. Acceptance of Terms</h2>
      <p>By using the Elite Goats platform, you agree to be bound by these Terms of Service.</p>
      <h2>2. User Roles</h2>
      <ul>
        <li><strong>Customer:</strong> Browse and purchase live animals and meat products.</li>
        <li><strong>Farmer:</strong> List goats and sheep for sale after admin approval.</li>
        <li><strong>Butcher:</strong> Purchase animals and list meat products.</li>
        <li><strong>Admin:</strong> Manages the platform and approves listings.</li>
      </ul>
      <h2>3. Account Registration</h2>
      <ul>
        <li>You must provide accurate information when registering.</li>
        <li>You must be at least 18 years old to use this platform.</li>
      </ul>
      <h2>4. Prohibited Activities</h2>
      <ul>
        <li>No false or fraudulent listings</li>
        <li>No illegal activity</li>
        <li>No hacking or disrupting services</li>
      </ul>
      <h2>5. Contact Us</h2>
      <p>Email: support@elitemeat.co.in</p>
    </div>
  );
};

export default TermsOfService;